import { css } from '@emotion/css';

export const progressbarStyles = css`
  transition: transform 0.12s linear;
`;

export const backgroundTransparent = css`
  background-color: transparent;
`;
